import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { StepFormService } from 'src/app/services/StepForm/step-form.service';

@Injectable({
  providedIn: 'root'
})
export class ClearRouteGuard implements CanDeactivate<any> {
  constructor(private stepFormService: StepFormService) {}

  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (nextState?.url.includes('/empresa/listagem/agendamento')) {
      this.stepFormService.reset();
    }

    return true;
  }
}
